var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"text-center py-12"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1):(!_vm.hasData)?_c('div',{staticClass:"text-center py-12",style:({ height: _vm.height })},[_vm._v("\n  No data available\n")]):_c('highcharts',{attrs:{"options":_vm.chartOptions,"callback":_vm.onCallbackChart}})
}
var staticRenderFns = []

export { render, staticRenderFns }